import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "@/config/customBaseQuery";

export const dashboardApi = createApi({
    reducerPath: "dashboardApi",

    baseQuery: customBaseQuery,

    endpoints: (builder) => ({
        getAdminDashboard: builder.query({
            query: () => ({
                url: "/v1/AdminDashboard/GetAdminDashboardDetail",
                method: "GET",
            }),

            transformResponse: (response) => {
                return response?.data?.[0] ?? null;
            },

            keepUnusedDataFor: 1 * 60,
            refetchOnMountOrArgChange: false,
        }),
    }),
});

export const {
    useGetAdminDashboardQuery,
} = dashboardApi;